import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Space,
    Tabs,
    Checkbox,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  import { connect } from "react-redux";
  // import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
  import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    RangePickerItem,
    TableItem,
    dineroDisabledMask,
    ButtonItem,
    ErrorItem
  } from "../../../../Components/Items";
  import reporteDeIngresosPdf from "../../../../Pdf/reporteDeIngresosPdf";
  import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
  import * as XLSXStyle from "xlsx-js-style";
  import {
    headerStyle,
    celdaTexto,
    celdaMoneda,
    totalTextoStyle,
    totalMoneyStyle,
    nombreVendedor,
  } from "../../../../Components/ExcelEstilos";
  import { ResponsiveLine } from "@nivo/line";
  import moment from "moment";
  import "moment/locale/es";
import reporteDeIngresosAgrupadosPdf from "../../../../Pdf/reporteDeIngresosAgrupadosPdf";
  moment.locale("es");
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
  const { Option } = Select;
  const { TabPane } = Tabs;

  // Columnas del reporte (tabla y Excel). Sin "Mostrar vendedor" ni "Desglosar impuestos" son
  // las nueve de siempre. Las banderas se leen de la respuesta del backend para que lo que se
  // ve y se descarga corresponda a lo que se consulto, aunque luego se cambien las casillas.
  const columnasReporteIngresos = (dataReporte) => {
    const mostrarVendedor = dataReporte?.mostrarVendedor === true;
    const desglosarImpuestos = dataReporte?.desglosarImpuestos === true;
    return [
      { titulo: "Banco", campo: "banco", wch: 22 },
      { titulo: "Fecha", campo: "fechaPago", fecha: true, wch: 12 },
      { titulo: "Cliente", campo: "cliente", wch: 40 },
      ...(mostrarVendedor ? [{ titulo: "Vendedor", campo: "vendedor", wch: 28 }] : []),
      { titulo: "Venta", campo: "venta", wch: 18 },
      ...(mostrarVendedor || desglosarImpuestos ? [{ titulo: "Origen", campo: "origen", wch: 18 }] : []),
      { titulo: "Proyecto", campo: "proyecto", wch: 18 },
      { titulo: "Forma De Pago", tituloTabla: "Forma de pago", campo: "formaDePago", wch: 20 },
      { titulo: "Moneda", campo: "moneda", wch: 9 },
      ...(desglosarImpuestos
        ? [
            { titulo: "Subtotal", campo: "subtotal", dinero: true, wch: 16 },
            { titulo: "IVA", campo: "iva", dinero: true, wch: 14 },
            ...(dataReporte?.hayOtrosImpuestos
              ? [{ titulo: "Otros Imp.", campo: "otrosImpuestos", dinero: true, wch: 14 }]
              : []),
            { titulo: "Retenciones", campo: "retenciones", dinero: true, wch: 14 },
          ]
        : []),
      { titulo: desglosarImpuestos ? "Total" : "Monto", campo: "monto", dinero: true, wch: 16 },
      { titulo: "Referencia", campo: "referencia", wch: 20 },
    ];
  };

  const compararCampo = (campo) => (a, b) => {
    if (a[campo] < b[campo]) {
      return -1;
    }
    if (a[campo] > b[campo]) {
      return 1;
    }
    return 0;
  };

  const compararFechaPago = (a, b) => {
    if (moment(a.fechaPago, "DD/MM/YYYY") < moment(b.fechaPago, "DD/MM/YYYY")) {
      return -1;
    }
    if (moment(a.fechaPago, "DD/MM/YYYY") > moment(b.fechaPago, "DD/MM/YYYY")) {
      return 1;
    }
    return 0;
  };

  // Los renglones sin venta no traen desglose: celda vacia en lugar de $0.00
  const textoDinero = (valor) =>
    valor === null || valor === undefined ? "" : dineroDisabledMask(valor);

  const redondear2 = (valor) => Math.round(valor * 100) / 100;

  class ReporteIngresos extends Component {
    state = {
      loading: false,
      pdf: null,
      objetoBancos: null,
      todasBancos: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoUniadesDeNegocio: null,
      todasUniadesDeNegocio: null,
      objetoUsuarios: null,
      dataReporte: null,
      todosPagos: [],
      dataGrafico: [],
      total: 0,
    };
  
    atras() {
        this.props.history.goBack();
    }
  
    async componentDidMount() {
      this.setState({ loading: true });
      await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: res.data });
          this.setState({
            objetoBancos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.banco}
                </Option>
              );
            }),
          });
        }
      });
      await axios
      .post(
        "cajaefectivo/selectCajaEfectivo",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: this.state.todasBancos && this.state.todasBancos?.length > 0 ? [...this.state.todasBancos, ...res.data] : res.data });
          this.setState({
            objetoBancos: this.state.objetoBancos && this.state.objetoBancos?.length > 0 ? [...this.state.objetoBancos ,...res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            })] : res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            }),
          });
        }
      });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUniadesDeNegocio: res.data });
            this.setState({
              objetoUniadesDeNegocio: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "usuarios/selectUsuariosEmpresa",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoUsuarios: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {nombreVendedor(value)}
                </Option>
              )),
            });
          }
        });
      this.consultarReporteIngresos({
        periodo: [moment().subtract(1, "month"), moment()],
        bancos: 0,
        filtrarProyecto: 0,
      });
    }
  
    async crearGrafico(valuePagos, fechaInicial, fechaFinal) {
      let grafico = [];
      let graficoSumatoria = [];
      let sumatoria = 0;
  
      let fechaCambiante = moment(fechaInicial).locale("es");
      const fechaFinalMoment = moment(fechaFinal).locale("es");
  
      if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
        while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago)) {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "date"
              );
            } else {
              return false;
            }
          });
  
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
        while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago)) {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "week"
              );
            } else {
              return false;
            }
          });
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
        while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago)) {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "month"
              );
            } else {
              return false;
            }
          });
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
        }
      } else {
        while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago)) {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "year"
              );
            } else {
              return false;
            }
          });
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "year").locale("es");
        }
      }
  
      await this.setState({
        dataGrafico: [
          {
            id: "Ingresos",
            color: "hsl(15, 70%, 50%)",
            data: grafico,
          },
          {
            id: "Ingresos Acumulados",
            color: "hsl(15, 70%, 50%)",
            data: graficoSumatoria,
          },
        ],
      });
    }
  
    consultarReporteIngresos(values) {
      this.setState({ loading: true });
      axios
        .post(
          "reportesAdministrativos/reporteIngresos",
          { ...values, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.crearGrafico(
              res.data.pagos,
              res.data.fechaInicial,
              res.data.fechaFinal
            );
            this.setState({
              loading: false,
              dataReporte: res.data,
              todosPagos: res.data.pagos,
              total: res.data.total,
            });
          } else if (res.data.success === 1) {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          } else {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          }
          this.setState({ loading: false });
        });
    }
  
    descargarExcel() {
      const columnas = columnasReporteIngresos(this.state.dataReporte);
      const sumarColumna = (campo) =>
        redondear2(this.state.todosPagos.reduce((acc, valuePago) => acc + (Number(valuePago[campo]) || 0), 0));

      const filas = [
        columnas.map((columna) => celdaTexto(columna.titulo, headerStyle)),
        ...this.state.todosPagos.map((valuePago) =>
          columnas.map((columna) =>
            columna.dinero ? celdaMoneda(valuePago[columna.campo]) : celdaTexto(valuePago[columna.campo])
          )
        ),
        columnas.map((columna, index) => {
          if (index === 0) return celdaTexto("Total", totalTextoStyle);
          if (columna.dinero) return celdaMoneda(sumarColumna(columna.campo), totalMoneyStyle);
          return celdaTexto("", totalTextoStyle);
        }),
      ];

      const worksheet = XLSXStyle.utils.aoa_to_sheet(filas);
      worksheet["!cols"] = columnas.map((columna) => ({ wch: columna.wch }));
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Reporte Ingresos");
      XLSXStyle.writeFile(workbook, `Reporte_De_Ingresos_${moment().locale("es").format("L")}.xlsx`);
    }
  
    descargarPdf() {
      pdfMake
        .createPdf(reporteDeIngresosPdf(this.state.dataReporte))
        .download(`Reporte_De_Ingresos_${moment().locale("es").format("L")}`);
    }

    descargarAgrupadoPdf() {
      pdfMake
        .createPdf(reporteDeIngresosAgrupadosPdf(this.state.dataReporte))
        .download(`Reporte_De_Ingresos_Agrupados_${moment().locale("es").format("L")}`);
    }
  
    onFinishFailed(e) {
      ErrorItem(e);
    }
    render() {
      const columns = columnasReporteIngresos(this.state.dataReporte).map((columna) => ({
        title: columna.tituloTabla || columna.titulo,
        dataIndex: columna.campo,
        key: columna.campo,
        sorter: columna.fecha ? compararFechaPago : compararCampo(columna.campo),
        buscar: columna.campo,
        ...(columna.dinero ? { render: (value) => textoDinero(value), align: "right" } : {}),
        ellipsis: true,
      }));
      return (
        <>
          <Form
            ref={this.formRef}
            name="reporteIngresos"
            onFinish={this.consultarReporteIngresos.bind(this)}
            onFinishFailed={this.onFinishFailed}
            initialValues={{
              periodo: [moment().subtract(1, "month"), moment()],
            }}
          >
            <PageHeader
              onBack={this.atras.bind(this)}
              title="Reporte Ingresos"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
              extra={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarExcel()}
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel
                      </ButtonItem>
                    )}
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarAgrupadoPdf()}
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Agrupado PDF
                      </ButtonItem>
                    )}
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarPdf()}
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar PDF
                      </ButtonItem>
                    )}
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Consultar
                    </ButtonItem>
                  </Space>
                </div>
              }
            />
            <Spin spinning={this.state.loading}>
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingTop: 5,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <Tabs
                  style={{ margin: 0 }}
                  tabBarExtraContent={{
                    left: (
                      <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                        Filtros:
                      </h1>
                    ),
                  }}
                >
                  <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                    <FormItem name="periodo" required noStyle>
                      <RangePickerItem />
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="2" key="2" forceRender tab="Bancos">
                    <FormItem name="bancos" noStyle margin>
                      <SelectItem
                        width="90%"
                        mode="multiple"
                        placeholder="Bancos"
                      >
                        {this.state.objetoBancos}
                      </SelectItem>
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                    <Row>
                      <Col span={8}>
                        <FormItem
                          name="filtrarProyecto"
                          required
                          noStyle
                          initialValue={0}
                        >
                          <SelectItem width="90%" placeholder="Filtrar Proyecto">
                            <Option default value={0}>
                              Niguno
                            </Option>
                            <Option value={1}>Proyectos</Option>
                            <Option value={2}>Unidades de negocio</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const filtrarProyecto =
                              getFieldValue("filtrarProyecto");
                            if (filtrarProyecto === 1) {
                              return (
                                <FormItem required name="proyectos" margin noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Proyectos"
                                    mode="multiple"
                                  >
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                            if (filtrarProyecto === 2) {
                              return (
                                <FormItem required margin name="unidadDeNegocioId" noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Unidades de Negocio"
                                  >
                                    {this.state.objetoUniadesDeNegocio}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem
                        label="Solo Ventas"
                        name="soloVentas"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Mostrar Vendedor"
                        name="mostrarVendedor"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Desglosar Impuestos"
                        name="desglosarImpuestos"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                  </Row>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      if (!getFieldValue("mostrarVendedor")) {
                        return null;
                      }
                      return (
                        <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                          <Col span={16}>
                            <FormItem label="Vendedores" name="vendedores" margin>
                              <SelectItem
                                width="100%"
                                mode="multiple"
                                placeholder="Todos los vendedores"
                              >
                                {this.state.objetoUsuarios}
                              </SelectItem>
                            </FormItem>
                          </Col>
                          <Col span={8}>
                            <FormItem
                              label="Agrupar PDF por"
                              name="agruparPdfPor"
                              initialValue="formaDePago"
                              margin
                            >
                              <SelectItem placeholder="Agrupar PDF por">
                                <Option value="formaDePago">Forma de pago</Option>
                                <Option value="vendedor">Vendedor</Option>
                              </SelectItem>
                            </FormItem>
                          </Col>
                        </Row>
                      );
                    }}
                  </FormItem>
                </TabPane>
                </Tabs>
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingBottom: 35,
                  marginTop: 10,
                  marginBottom: 10,
                  height: 420,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>Gráfico</h1>

                <ResponsiveLine
                  data={this.state.dataGrafico}
                  margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                  // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                  enableSlices="x"
                  useMesh={true}

                  yFormat={(e) => dineroDisabledMask(Math.abs(e))}

                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: 0,
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}

                  curve="monotoneX"
                  lineWidth={2}

                  // ✅ Menos ruido visual
                  pointSize={5}
                  pointBorderWidth={1}
                  pointColor={{ theme: "background" }}
                  pointBorderColor={{ from: "serieColor" }}

                  // Si quieres aún más limpio, descomenta:
                  // enablePoints={false}

                  colors={["#ff6633", "#FF926E"]}
                  colorBy="index"

                  axisTop={null}
                  axisRight={null}

                  axisBottom={{
                    tickSize: 5,
                    tickPadding: 8,
                    tickRotation: 45,
                    // ✅ muestra menos etiquetas (una de cada 2 o 3)
                    tickValues: (this.state.dataGrafico?.[0]?.data || [])
                      .map(d => d.x)
                      .filter((_, i) => i % 2 === 0),
                  }}

                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 8,
                    format: (v) => dineroDisabledMask(Math.abs(v)),
                  }}

                  // ✅ Grid más limpio
                  enableGridX={false}

                  legends={[
                    {
                      anchor: "top-right",
                      direction: "column",
                      translateX: 0,
                      translateY: 0,
                      itemWidth: 130,
                      itemHeight: 18,
                      symbolSize: 10,
                      symbolShape: "circle",
                      itemOpacity: 0.85,
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  padding: 15,
                  marginBottom: 10,
                  height: "75px",
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <Row>
                  {this.state.dataReporte?.desglosarImpuestos === true &&
                    [
                      { titulo: "Subtotal", valor: this.state.dataReporte.totales?.subtotal },
                      { titulo: "IVA", valor: this.state.dataReporte.totales?.iva },
                      ...(this.state.dataReporte.hayOtrosImpuestos
                        ? [{ titulo: "Otros Impuestos", valor: this.state.dataReporte.totales?.otrosImpuestos }]
                        : []),
                      { titulo: "Retenciones", valor: this.state.dataReporte.totales?.retenciones },
                    ].map((totalDesglose) => (
                      <Col flex={1} key={totalDesglose.titulo} style={{ textAlign: "center" }}>
                        <p style={{ margin: 0 }}>{totalDesglose.titulo}</p>
                        <h1 style={{ fontSize: 15 }}>
                          {dineroDisabledMask(totalDesglose.valor || 0)}
                        </h1>
                      </Col>
                    ))}
                  <Col
                    {...(this.state.dataReporte?.desglosarImpuestos === true ? { flex: 1 } : { span: 24 })}
                    style={{ textAlign: "center" }}
                  >
                    <p style={{ margin: 0 }}>Total</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.total)}
                    </h1>
                  </Col>
                </Row>
              </div>
              <TableItem
                // onRow={(record, rowIndex) => {
                //   return {
                //     onDoubleClick: (event) => {
                //       this.props.history.push("/panel/verVenta", {
                //         id: record._id,
                //       });
                //     },
                //   };
                // }}
                rowKey={(value) => value._id.toString() + Math.random()}
                columns={columns}
                dataSource={this.state.todosPagos}
                size="small"
                pagination={false}
              />
              {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
            </Spin>
          </Form>
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };
  
  export default connect(mapStateToProps)(ReporteIngresos);
  